import type { SpotResponse } from '../types/api';

/** Great-circle distance in metres (haversine). */
export function haversineMeters(
  lat1: number, lng1: number, lat2: number, lng2: number,
): number {
  const R = 6_371_000;
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/** Nearest spot within radiusMeters of (lat,lng), or null if none. */
export function nearestSpot(
  spots: SpotResponse[], lat: number, lng: number, radiusMeters = 200,
): SpotResponse | null {
  let best: SpotResponse | null = null;
  let bestDist = Infinity;
  for (const s of spots) {
    const d = haversineMeters(lat, lng, s.latitude, s.longitude);
    if (d <= radiusMeters && d < bestDist) { best = s; bestDist = d; }
  }
  return best;
}
